import { Box, styled } from '@planne-software/uni/mui/material';
import { Button } from '@planne-software/uni/Button';

export const BarRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'visible',
})<{ visible: boolean }>(({ theme, visible }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  fontFamily: "'Work Sans', sans-serif",
  gap: theme.tokens.spacing['spacing-1xmini'],
  backgroundColor: theme.tokens.colors['fill-color-neutral'],
  borderTop: `1px solid ${theme.tokens.colors['border-color-neutral-softer']}`,
  borderTopLeftRadius: theme.tokens.radius['border-radius-md'],
  borderTopRightRadius: theme.tokens.radius['border-radius-md'],
  padding: theme.tokens.spacing['spacing-xs'],
  boxShadow: '0 -1.25rem 1.5rem -0.25rem rgba(16,24,40,0.1), 0 -0.5rem 0.5rem -0.25rem rgba(16,24,40,0.1)',
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0)' : 'translateY(100%)',
  transition: 'opacity 200ms ease, transform 200ms ease',
  pointerEvents: visible ? 'auto' : 'none',
}));

export const ViewSummaryLink = styled('button')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-semibold'],
  alignSelf: 'center',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: theme.tokens.colors['fill-color-primary-base'],
}));

export const PriceRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'stacked',
})<{ stacked: boolean }>(({ theme, stacked }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: stacked ? 'column' : 'row',
  alignItems: stacked ? 'flex-start' : 'center',
  justifyContent: 'space-between',
  gap: theme.tokens.spacing['spacing-1xmini'],
}));

export const PriceInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const PriceLabel = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-xs-medium'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const PriceValue = styled('span')(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.75rem',
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const CtaButton = styled(Button, { shouldForwardProp: (prop) => prop !== 'actionColor' })<{
  actionColor: string;
}>(({ actionColor }) => ({
  backgroundColor: actionColor,
  '&:hover': {
    backgroundColor: actionColor,
    filter: 'brightness(0.92)',
  },
}));
